document.addEventListener('DOMContentLoaded', function() {
    // Open popup
    document.querySelectorAll('.popup-open').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            const popupId = this.getAttribute('data-popup');
            const popup = document.getElementById(popupId);
            if (popup) {
                popup.style.display = 'flex';
                document.body.style.overflow = 'hidden';
            }
        });
    });

    // Close popup
    document.querySelectorAll('.popup-close').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            const popupId = this.getAttribute('data-popup');
            const popup = document.getElementById(popupId);
            if (popup) {
                popup.style.display = 'none';
                document.body.style.overflow = 'auto';
                const emailInput = document.getElementById('recover-email');
                const errorDiv = document.getElementById('recover_email_error');
                errorDiv.style.display = 'none';
                emailInput.classList.remove('input-error');
                document.getElementById('recover_customer_password').reset();
            }
        });
    });

    // Close popup when clicking outside
    document.querySelectorAll('.popup-content').forEach(function(popup) {
        popup.addEventListener('click', function(e) {
            if (e.target === this) {
                this.style.display = 'none';
                document.body.style.overflow = 'auto';
                document.getElementById('recover_customer_password').reset();
                const emailInput = document.getElementById('recover-email');
                const errorDiv = document.getElementById('recover_email_error');
                errorDiv.style.display = 'none';
                emailInput.classList.remove('input-error');
                document.getElementById('recover_customer_password').reset();
            }
        });
    });

    // Close popup on filter selection (optional - removes the popup after selection)
    document.querySelectorAll('.filter-option-link').forEach(function(link) {
        link.addEventListener('click', function() {
            // Optional: Close popup after selection
            setTimeout(function() {
                document.querySelectorAll('.popup-content').forEach(function(popup) {
                    popup.style.display = 'none';
                    document.body.style.overflow = 'auto';
                });
            }, 100);
        });
    });
});